import AxiosInterceptor from "../../AxiosInterceptorMomthera";

// 환자 정보 리스트 조회
// request data
//  - pid
//  - text
//  - patient-type
//  - patient-group
//  - training
//  - order
//  - page
export function getPatientFromMomthera(request) {
    return AxiosInterceptor({
        url: '/patient',
        method: 'get',
        params: request
    })
}

// 환자 등록
// request data
//  - name
//  - birth
//  - phoneNumber
//  - patientGroup
//  - patientType
//  - psctCode
export function postPatientToMomthera(request) {
    return AxiosInterceptor({
        url: '/patient',
        method: 'post',
        data: request
    })
}

// 환자 수정
// request data
//  - psctId
//  - name
//  - birth
//  - phoneNumber
//  - patientGroup
//  - patientType
export function putPatientToMomthera(request) {
    return AxiosInterceptor({
        url: '/patient',
        method: 'put',
        data: request
    })
}


// 환자 삭제
// request data
//  - psctId 리스트
export function deletePatientFromMomthera(request) {
    return AxiosInterceptor({
        url: '/patient',
        method: 'delete',
        data: request
    })
}

// 의료진 처방코드 발번
export function getPatientPsctcodeFromMomthera() {
    return AxiosInterceptor({
        url: '/patient/psct-code',
        method: 'get'
    })
}